import { BaseApiService } from "../base/base-api.service";
import {
  TravelExpenseSuggestedAuditCommentDTO,
  TravelExpenseSuggestedAuditCommentSTO,
} from "../../models/travel-expense-suggested-audit-comment";

export class TravelExpenseSuggestedAuditCommentApiService extends BaseApiService<
  TravelExpenseSuggestedAuditCommentDTO,
  TravelExpenseSuggestedAuditCommentSTO
> {
  constructor() {
    super({
      servicePath: "/TravelExpenseSuggestedAuditComment",
      loadItemsPath: "/GetTravelExpenseSuggestedAuditComment",
      saveItemsPath: "/SaveTravelExpenseSuggestedAuditComment",
    });
  }
}
